export default "__VITE_ASSET__BoHpVc9M__"